import { Link } from "@tanstack/react-router";

import { Badge } from "../ui/badge";
import { Card } from "../ui/card";

const settingsLinks = [
  { title: "Team", detail: "Collaborators and contact channels.", to: "/settings/team" },
  { title: "Routes", detail: "Vonigo routes and primary collaborators.", to: "/settings/routes" },
  { title: "Who gets alerted", detail: "Alert routing by route, role, and channel.", to: "/settings/routing" },
  { title: "Brand", detail: "Tenant identity, sender profile, phones, and URLs.", to: "/settings/brand" },
  { title: "Users", detail: "Dashboard logins and permissions.", to: "/settings/users" },
  { title: "Automations", detail: "Owner on/off switchboard for live timers.", to: "/settings/automations" },
  { title: "Templates", detail: "Review, referral, and follow-up copy.", to: "/settings/templates" },
  { title: "Agent learning", detail: "Observation log before any experiment is approved.", to: "/insights" },
  { title: "Scoring", detail: "Lead scoring rules and thresholds.", to: "/settings/scoring" },
  { title: "Territories", detail: "Territory codes and ZIP coverage.", to: "/settings/territories" },
];

export function SettingsContent() {
  return (
    <section className="space-y-5">
      <div>
        <Badge variant="slate">Admin</Badge>
        <h1 className="mt-3 text-2xl font-semibold text-slate-950">Setup and controls</h1>
        <p className="mt-1 max-w-3xl text-sm text-slate-600">
          Manage the configuration Antonio should not need during normal daily work.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {settingsLinks.map((link) => (
          <Link key={link.to} to={link.to} className="block">
            <Card className="h-full p-4 transition-colors hover:border-slate-300 hover:bg-slate-50">
              <div className="text-sm font-semibold text-slate-950">{link.title}</div>
              <p className="mt-2 text-xs leading-relaxed text-slate-500">{link.detail}</p>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
}
